import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/chat/world.svg'


const _withScopeId = n => (_pushScopeId("data-v-dce3e8cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "languageChange" }
const _hoisted_2 = ["onClick"]

import store from "@/store";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { event } from "vue-gtag";
import { gaEvent } from "@/utils/format";
import { changeCountry } from "@/api/devices";

// 多语言切换
type Props = {
  send: Number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'languageChange',
  props: {
    send: { default: () => 0 }
  },
  setup(__props: any) {

const { locale } = useI18n();
const storeCurrentLang = computed(() => store.state.currentLang);
// console.log(storeCurrentLang, 'storeCurrentLang');

// let currentLang = storeCurrentLang.value || "English";
let currentLang = ref(storeCurrentLang.value);
const language = ref(currentLang);

const userId = computed(() => store.state.userInfo.id);
// const vClickOutside = {
//   mounted(el: any, binding: any, node: any) {
//     console.log(el, 'el');
//     console.log(binding, 'binding');
//     console.log(node, 'node');
//     const eventHandler = function eventHandler(e: any) {
//       console.log(e, 'e');

//       // 如果当前点击的dom包含在指定作用的dom节点上，则不做任何处理
//       if (el.contains(e.target)) {
//         return false
//       }
//       // 如果绑定的参数是函数，正常情况也应该是函数，执行
//       if (binding.value && typeof binding.value === 'function') {
//         binding.value(e)
//       }
//     }

//     // 用于销毁前注销事件监听
//     el.__click_outside__ = eventHandler
//     document.addEventListener('click', eventHandler)
//   },
//   unmounted(el: any, binding: any, node: any) {
//     // 移除事件监听
//     document.removeEventListener('click', el.__click_outside__)
//     // 删除无用属性
//     delete el.__click_outside__
//   }
// }

// 点击除语言切换组件之外的任意位置隐藏popover
const handleClickOutside = () => {
  // console.log('handleClickOutside');
  visible.value = false;
};

const newWidth = computed(() => {
  if (languageOptions.value.length <= 8) {
    return 140 + "px";
  } else {
    return 280 + "px";
  }
});

// 默认选中项的下标
const activeIndex = ref();
const visible = ref(false);
const languageOptions = ref([
  {
    value: "en",
    label: "English", // 英语
  },
  {
    value: "de",
    label: "German", // 德语
  },
  {
    value: "es",
    label: "Spanish", // 西班牙语
  },
  {
    value: "fr",
    label: "French", // 法语
  },
  {
    value: "ja",
    label: "Japanese", // 日语
  },
  {
    value: "ru",
    label: "Russian", // 俄语
  },
  {
    value: "pt",
    label: "Portuguese", // 葡萄牙语(巴西语)
  },
  // ar需要特殊处理:ar-SA、ar-EG
  {
    value: "ar",
    label: "Arabic", // 阿拉伯语
  },
  {
    value: "it",
    label: "Italy", // 意大利语
  },
  {
    value: "ko",
    label: "Korean", // 韩语
  },
  {
    value: "nl",
    label: "Dutch", // 荷兰语
  },
  {
    value: "tr",
    label: "Turkish", // 土耳其语
  },
  {
    value: "id",
    label: "Indonesia", // 印度尼西亚语
  },
  {
    value: "th",
    label: "Thai", // 泰国语
  },
  {
    value: "ms",
    label: "Melayu", // 马来语
  },
  {
    value: "zh-TW",
    label: "Traditional Chinese", // 繁体中文
  },
  {
    value: "zh-CN",
    label: "Simplified Chinese", // 简体中文
  },
]);
const changeLanguage = (value: any, index: any) => {
  // 点击语言切换后统计一次
  gaEvent("Change_Language", {
    event_category: "LogRegister",
    event_label: value,
  });
  // console.log(value, index);
  activeIndex.value = index;
  locale.value = value;
  language.value = value;
  currentLang.value = value;
  store.commit("setCurrentLang", value);
  console.log("value:", value);
  // localStorage.setItem("lang", value);
  visible.value = false;
  let tempValue = value
  if (tempValue == 'ja') tempValue = 'jp'
  else if (tempValue == 'ms') tempValue = 'my'
  else if (tempValue == 'ko') tempValue = 'kr'
  else if (tempValue == 'pt') tempValue = 'br'
  else if (tempValue == 'zh-CN') tempValue = 'cn'
  else if (tempValue == 'zh-TW') tempValue = 'tw'
  let params = {
    language: tempValue
  }
  changeCountry(params, userId.value).then((res) => {
    console.log("成功了老弟");
  }).catch((e) => {
    console.log("eeee:", e);
  })
};
const handleLanguageClick = () => {
  visible.value = !visible.value;
};


return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      "popper-class": "myPopover",
      width: newWidth.value,
      visible: visible.value
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass([
          _ctx.send == 1 ? 'worldWrapperHome' : 'worldWrapper',
          visible.value ? 'active' : '',
        ]),
          onClick: handleLanguageClick
        }, [
          _createElementVNode("img", {
            class: _normalizeClass(_ctx.send == 1 ? 'imgHome' : ''),
            src: _imports_0
          }, null, 2),
          _withDirectives(_createElementVNode("span", { class: "sengLanguage" }, _toDisplayString(_ctx.$t("language")), 513), [
            [_vShow, _ctx.send == 1]
          ])
        ], 2)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "langBox",
          style: _normalizeStyle({ width: newWidth.value })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageOptions.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['langItem', item.value == _unref(currentLang) ? 'itemActive' : '']),
              key: item.value,
              onClick: ($event: any) => (changeLanguage(item.value, index))
            }, _toDisplayString(item.label), 11, _hoisted_2))
          }), 128))
        ], 4)
      ]),
      _: 1
    }, 8, ["width", "visible"])
  ])), [
    [_directive_click_outside, handleClickOutside]
  ])
}
}

})